(() => {

    class DeletePageModal {
        constructor(
            $scope,
            $state,
            $uibModalInstance,
            LandingPagesService,
            landingPage) {
            $scope.close = $uibModalInstance.close;
            $scope.deleteLandingPage = function () {
                LandingPagesService.deleteLandingPage(landingPage.Id)
                    .finally(() => {
                        $uibModalInstance.close(true);
                        $state.go("app.landingpages");
                    })
            }
        }
    }

    angular.module("dashboard")
        .controller("deletePageModal", [
            "$scope",
            "$state",
            "$uibModalInstance",
            "LandingPagesService",
            "landingPage",
            DeletePageModal
        ])
})();
